export const isValidImageUrl = async (url: string | undefined): Promise<boolean | undefined> => {
  try {
    const res = await fetch(url ?? "", { method: "HEAD" });
    return res.headers.get("Content-Type")?.startsWith("image");
  } catch {
    return false;
  }
};
